import React from "react";
import { Dropdown, DropdownButton, Row } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ExaminationStatus from "../../../helpers/ExaminationStatus";

class ExaminationActionCell extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isDropdownDisabled = this.isDropdownDisabled.bind(this);
  }

  isDropdownDisabled(status) {
    return (
      !ExaminationStatus.showClose(status) &&
      !ExaminationStatus.showOpen(status) &&
      !ExaminationStatus.showDelete(status) &&
      //!ExaminationStatus.showPause(status) &&
      //!ExaminationStatus.showResume(status) &&
      !ExaminationStatus.showRetry(status)
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Row style={{ marginLeft: "-3px", float: "right" }}>
        <div style={{}}>
          <DropdownButton
            size="sm"
            disabled={this.isDropdownDisabled(this.props.exam.status)}
            onClick={event => event.stopPropagation()}
            id="dropdown-basic-button"
            title={<FontAwesomeIcon icon={faCogs} />}
            className="btn-green"
          >
            {ExaminationStatus.showEdit(this.props.exam.status) && (
              <Dropdown.Item
                as={Link}
                to={{
                  pathname: `/examinations/${this.props.exam._id}`,
                  state: {
                    examination: this.props.exam
                  }
                }}
              >
                {t("Examinations.ActionCell.EditOption")}
              </Dropdown.Item>
            )}
            {ExaminationStatus.showOpen(this.props.exam.status) && (
              <Dropdown.Item onClick={this.props.onOpen}>
                {t("Examinations.ActionCell.OpenOption")}
              </Dropdown.Item>
            )}
            {ExaminationStatus.showClose(this.props.exam.status) && (
              <Dropdown.Item onClick={this.props.onClose}>
                {t("Examinations.ActionCell.CloseOption")}
              </Dropdown.Item>
            )}
            {/**ExaminationStatus.showPause(this.props.exam.status) &&
            this.props.exam.instanceTemplate &&
              this.props.exam.instanceTemplate.type === 0 && (
                <Dropdown.Item onClick={this.props.onPause}>
                  {t("Examinations.ActionCell.PauseOption")}
                </Dropdown.Item>
              )**/}
            {/**ExaminationStatus.showResume(this.props.exam.status) &&
            this.props.exam.instanceTemplate &&
              this.props.exam.instanceTemplate.type === 0 && (
                <Dropdown.Item onClick={this.props.onResume}>
                  {t("Examinations.ActionCell.ResumeOption")}
                </Dropdown.Item>
              )**/}
            {ExaminationStatus.showRetry(this.props.exam.status) && (
              <Dropdown.Item onClick={this.props.onRetry}>
                {t("Examinations.ActionCell.RetryOption")}
              </Dropdown.Item>
            )}
            <Dropdown.Item onClick={this.props.onClone}>
              {t("Examinations.ActionCell.CloneOption")}
            </Dropdown.Item>
            {ExaminationStatus.showDelete(this.props.exam.status) && (
                <>
                <Dropdown.Divider />
                <Dropdown.Item onClick={this.props.onDelete}>
                  {t("Examinations.ActionCell.DeleteOption")}
                </Dropdown.Item>
                </>
            )}
          </DropdownButton>
        </div>
      </Row>
    );
  }
}

export default withTranslation()(ExaminationActionCell);
